import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { BASESITEID } from 'src/pages/equity/components/common/constants';
import {
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
} from 'src/pages/more/pages/productGuide/redux/action/actionTypes';
import { 
    getCategoryAndBrandsDataService,
    getCategoryAndBrandsApiEndpoint 
} from 'src/pages/more/pages/productGuide/redux/services';

export default function* getCategoryAndBrands(action) {
    const { countryISOCode } = yield select((state) => ({
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode
    }));
    const isMastOrder = false;
    const baseSiteId = localStorage.getItem('baseSiteId');
    const apiEndpoint = getCategoryAndBrandsApiEndpoint(baseSiteId, isMastOrder);
    
    try {
        const result = yield getCategoryAndBrandsDataService(baseSiteId, isMastOrder);
        const updatedData = result?.brandData?.map((item) => {
            return {
                ...item,
                isChecked: false,
            };
        });
        result.brandData = updatedData;
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS,
            categoryAndBrands: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: apiEndpoint,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}